import styles from "./VerticalTextSlide.module.css";
// import { useState } from "react";

function VerticalTextSlide({ options = [], prefix, id }) {
    return (
        <div className={styles.vertical_text_slide_wrapper} id={id}>
            <span className={styles.prefix}>{prefix}</span>
            <div className={styles.options_container}>
                {options.map((t, index) => (
                    <span
                        style={{
                            animationDelay: `${(index - 1) * 2.5}s`,
                        }}
                        className={styles.option}
                        key={index}
                        data-play-pause="animation"
                    >
                        {t}
                    </span>
                ))}
            </div>
        </div>
    );
}

export default VerticalTextSlide;
